export const DATEFORMAT_EN = "EN";
export const DATEFORMAT_EN_US = "EN_US";
export const DATEFORMAT_EN_CA = "EN_CA";

// new 1
export const DATEFORMAT_BG = "BG"; // Bulgarian
export const DATEFORMAT_HR = "HR"; // Croatian
export const DATEFORMAT_EE = "EE"; // Estonian
export const DATEFORMAT_HU = "HU"; // Hungarian
export const DATEFORMAT_IE = "IE"; // Irish
export const DATEFORMAT_LV = "LV"; // Latvian
export const DATEFORMAT_LI = "LI"; // Lithuanian
export const DATEFORMAT_MT = "MT"; // Maltese
export const DATEFORMAT_RO = "RO"; // Romanian
export const DATEFORMAT_SK = "SK"; // Slovak
export const DATEFORMAT_SI = "SI"; // Slovenian
export const DATEFORMAT_LU = "LU"; // Luxembourg
export const DATEFORMAT_IS = "IS"; // Icelandic
export const DATEFORMAT_IM = "IM"; // Manx
// sub-national:
export const DATEFORMAT_WALES = "WA"; // Welsh (not a true country code)
export const DATEFORMAT_SCOTLAND = "S1"; // Scottish Gaelic (not a true country code)
export const DATEFORMAT_MAORI1 = "N1"; // Maori has 2 versions - "Ngā Rā o te Wiki" and "Kupu Arotau" (not a true country code)
export const DATEFORMAT_MAORI2 = "N2"; // Maori has 2 versions - "Ngā Rā o te Wiki" and "Kupu Arotau" (not a true country code)

export const DATEFORMAT_TAMIL = "I1";
export const DATEFORMAT_MARATHI = "I2";
export const DATEFORMAT_TELUGU = "I3";
export const DATEFORMAT_GUJARATI = "I4";
export const DATEFORMAT_PUNJABI = "I5";
export const DATEFORMAT_JAVANESE = "D1";

export const DATEFORMAT_MM = "MM"; // Myanmar
export const DATEFORMAT_PH = "PH"; // FIlipini
export const DATEFORMAT_TH = "TH"; // Thai
export const DATEFORMAT_GL = "GL"; // Greenlandic
export const DATEFORMAT_FO = "FO"; // Faroese

// other
export const DATEFORMAT_IN = "IN"; // Hindi
export const DATEFORMAT_BD = "BD"; // Bangladesh: Bengali
export const DATEFORMAT_SW = "SW"; // SWAHILI (many countries)
export const DATEFORMAT_AR = "AR"; // ARABIC (many countries)
export const DATEFORMAT_PK = "PK"; // Pakistan: Urdu
export const DATEFORMAT_IR = "IR"; // Persian
export const DATEFORMAT_VN = "VN"; // Vietnamese

export const DATEFORMAT_CN = "CN"; // Chinese
export const DATEFORMAT_CZ = "CZ"; // Czech
export const DATEFORMAT_FR = "FR"; // French
export const DATEFORMAT_DE = "DE"; // German
export const DATEFORMAT_DK = "DK"; // Denmark
export const DATEFORMAT_FI = "FI"; // Finnish
export const DATEFORMAT_GR = "GR"; // Greek
export const DATEFORMAT_HE = "HE"; // Hebrew
export const DATEFORMAT_ID = "ID"; // Indonesian
export const DATEFORMAT_IT = "IT"; // Italian
export const DATEFORMAT_JP = "JP"; // Japanese
export const DATEFORMAT_KR = "KR"; // Korean
export const DATEFORMAT_NL = "NL"; // Dutch
export const DATEFORMAT_NO = "NO"; // Norwegian
export const DATEFORMAT_PL = "PL"; // Polish
export const DATEFORMAT_PT = "PT"; // Portuguese
export const DATEFORMAT_RU = "RU"; // Russian
export const DATEFORMAT_ES = "ES"; // Spanish
export const DATEFORMAT_ES_US = "ES_US"; // Spanish (US)
export const DATEFORMAT_SE = "SE"; // Swedish
export const DATEFORMAT_TR = "TR"; // Turkish
export const DATEFORMAT_UA = "UA"; // Ukrainian
export const DATEFORMAT_MY = "MY"; // Malaysian

export const DATEFORMATS = [
  DATEFORMAT_EN,
  DATEFORMAT_EN_US,
  DATEFORMAT_EN_CA,
  DATEFORMAT_CN,
  DATEFORMAT_CZ,
  DATEFORMAT_FR,
  DATEFORMAT_DE,
  DATEFORMAT_HE,
  DATEFORMAT_ID,
  DATEFORMAT_IT,
  DATEFORMAT_JP,
  DATEFORMAT_PT,
  DATEFORMAT_RU,
  DATEFORMAT_ES,
  DATEFORMAT_ES_US,
  DATEFORMAT_TR,
  DATEFORMAT_UA,
  DATEFORMAT_DK,
  DATEFORMAT_FI,
  DATEFORMAT_KR,
  DATEFORMAT_LU,
  DATEFORMAT_NL,
  DATEFORMAT_NO,
  DATEFORMAT_PL,
  DATEFORMAT_SE,
  DATEFORMAT_GR,
  DATEFORMAT_BG,
  DATEFORMAT_HR,
  DATEFORMAT_EE,
  DATEFORMAT_HU,
  DATEFORMAT_IE,
  DATEFORMAT_LV,
  DATEFORMAT_LI,
  DATEFORMAT_MT,
  DATEFORMAT_RO,
  DATEFORMAT_SK,
  DATEFORMAT_SI,
  DATEFORMAT_SW,
  DATEFORMAT_AR,
  DATEFORMAT_IR,
  DATEFORMAT_VN,
  DATEFORMAT_BD,
  DATEFORMAT_IN,
  DATEFORMAT_PK,
  DATEFORMAT_IS,
  DATEFORMAT_IM,
  DATEFORMAT_MY,
  DATEFORMAT_MM,
  DATEFORMAT_PH,
  DATEFORMAT_TH,
  DATEFORMAT_GL,
  DATEFORMAT_FO,
  DATEFORMAT_WALES,
  DATEFORMAT_SCOTLAND,
  DATEFORMAT_MARATHI,
  DATEFORMAT_TELUGU,
  DATEFORMAT_GUJARATI,
  DATEFORMAT_PUNJABI,
  DATEFORMAT_JAVANESE,
  DATEFORMAT_TAMIL,
  DATEFORMAT_MAORI1,
  DATEFORMAT_MAORI2,
];

export const DATEFORMATS_OTHER = DATEFORMATS.slice(3);

export const THEME_LIGHT = "LIGHT";
export const THEME_DARK = "DARK";

export const ANSWERMODE_SUBMIT = "SUBMIT";

export const PRACTICEFORMAT_ISO = "ISO";
export const PRACTICEFORMAT_LONGMONTH = "LONGMONTH";

export const VISITS = "VISITS";